(function() {

  AOS.init();

  /**
  * The animateCounter function handles the actual incrementing logic.
  * It uses requestAnimationFrame for high-performance visual updates.
  */
  function animateCounter(el) {
    const target = parseInt(el.getAttribute('data-target'));
    const duration = 2000; // 2 seconds
    const start = 0;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Ease Out Quad function: t * (2 - t)
      // This makes the animation slow down at the end
      const easeProgress = progress * (2 - progress);

      const currentValue = Math.floor(easeProgress * (target - start) + start);

      // Format with commas if needed
      el.innerText = currentValue.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.innerText = target.toLocaleString();
      }
    }

    requestAnimationFrame(update);
  }

  /**
  * Intersection Observer starts the animation only when the element
  * enters the viewport.
  */
  const observerOptions = {
    threshold: 0.5 // Trigger when 50% of the element is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counters = entry.target.querySelectorAll('.counter');
        counters.forEach(animateCounter);
        // Unobserve after animating once
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe the container of the stats
  document.querySelectorAll('.stat-item').forEach(item => {
    observer.observe(item);
  });

})();